import React, { Component } from 'react'

import Modal from '../Modal/Modal'
import Form from '../Form/Form'

class EditBrandNames extends Component {

    state = {
        brandNames: this.props.brandNames.join('\n')
    }

    onSave = () => {
        this.props.onSave({
            brandNames: this.state.brandNames.split('\n').join(',')
        })
    }

    render() {
        const { brandNames = '' } = this.state

        return (
          <Modal
            narrow
            extraClassName="EditBrandNames"
            onCancel={this.props.onClose}
            onSave={this.onSave}
            saveText="Save"
            mode="edit"
            title="Brand names">
            <Form>
                <div>
                    <textarea 
                        placeholder="Brand names"
                        value={brandNames}
                        onChange={e => this.setState({ brandNames: e.target.value })} />
                </div>
            </Form>
          </Modal>
        )
    }
}

export default EditBrandNames



// WEBPACK FOOTER //
// ./src/components/LBUs/EditBrandNames.js